export default __webpack_public_path__ + "static/media/instagram.617454b3.svg";